import { Button, Checkbox, DatePicker, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useState ,useEffect } from 'react'
import "../MainCSS.css";
import "aos/dist/aos.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import { GetConsigneeMaster, GetCustomerMaster } from '../../AllAPI/MasterAPI/SalesMasterApi';
import { DispatchDeliverySummarySave, DispatchNumberByCustomerId, GetConsigneeForCustomer, GetDetailsByDispatchNUmberId, GetDispatchDeliverySummaryDetails, GetOrderDetailsDispatchDeliveryByOrderNumber } from '../../AllAPI/DispatchAPI/DispatchApi';
import dayjs from 'dayjs';

const DispatchDeliverySummary = () => {
    const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {};
  // const storedUserData = sessionStorage.getItem('userData') || '';

 const commonHeaders = {
  headers: {
    // createdBy: storedUserData || '',
    // updatedBy: storedUserData || '',
    createdBy: 1,
    updatedBy: 2,
    userIp: storedHeaders.userIp || '',
    userLat: storedHeaders.userLat || '',
    userLong: storedHeaders.userLong || '',
    deviceSign: storedHeaders.deviceSign || '',
  },
};

const commonHeaders1 = {
  headers: {
    createdBy: 1,
    updatedBy: 2,
  },
}


    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']


    const [loadingSummaryNo, setLoadingSummaryNo] = useState('');
const [summaryDate, setSummaryDate] = useState(dayjs());
const [customerName, setCustomerName] = useState(null);
const [consigneeName, setConsigneeName] = useState(null);
const [dispatchNumber, setDispatchNumber] = useState('');
const [dispatchNumbers, setDispatchNumbers] = useState([]);

const [orderNo, setOrderNo] = useState('');
const [poNumber, setPONumber] = useState('');
const [poDate, setPODate] = useState("");
const [vehicleNumber, setVehicleNumber] = useState('');
const [lrNo, setLRNo] = useState('');
const [paymentTerms, setPaymentTerms] = useState('');
const [packingCharges, setPackingCharges] = useState('');
const [freight, setFreight] = useState('');
const [finalTotal, setFinalTotal] = useState('');

// UI logic flags
const [submitButton, setSubmitButton] = useState(true);
const [updateButton, setUpdateButton] = useState(false);

// For dropdown options (replace with actual data fetching)
const [allCustomer, setAllCustomer] = useState([]);
const [allConsignees, setAllConsignees] = useState([]);
const [allOrders, setAllOrders] = useState([]);
// Validation errors
const [errors, setErrors] = useState({
  loadingSummaryNo: '',
  summaryDate: '',
  customerName: '',
  consigneeName: '',
  dispatchNumber: '',
  orderNo: '',
  poNumber: '',
  poDate: '',
  vehicleNumber: '',
  lrNo: '',
  paymentTerms: '',
  packingCharges: '',
  freight: '',
  finalTotal: '',
});
 const [DispatchData, setDispatchData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = DispatchData.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }
   const handleViewData = async () => {
    
     try {
      
   
       const response = await axios.get(
         GetDispatchDeliverySummaryDetails,
         commonHeaders1
       );
   
       const dispatchDetails = response.data;
   
       if (!dispatchDetails) {
         toast.error("Failed to fetch order details.");
         return;
       }
   
       if (Array.isArray(dispatchDetails) && dispatchDetails.length > 0) {
         setDispatchData(dispatchDetails);
         setFilteredData(dispatchDetails);
         setTotalEntries(dispatchDetails.length);
      
       } else {
         toast.warn("No items found for the selected order.");
         setDispatchData([]);
         setFilteredData([]);
         setTotalEntries(0);
       
       }
     } catch (error) {
       console.error("Error during API call:", error);
       toast.error("Error occurred while submitting data");
     }
   };
  const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Loading Summary No.",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => (a.id || '').toString().localeCompare((b.id || '').toString()),
  },
  {
    title: "Summary Date",
    dataIndex: "date",
    key: "date",
    sorter: (a, b) => (a.date || '').toString().localeCompare((b.date || '').toString()),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    sorter: (a, b) => (a.customerName || '').toString().localeCompare((b.customerName || '').toString()),
  },
  {
    title: "Consignee Name",
    dataIndex: "consigneeName",
    key: "consigneeName",
    sorter: (a, b) => (a.consigneeName || '').toString().localeCompare((b.consigneeName || '').toString()),
  },
  {
    title: "Dispatch Number",
    dataIndex: "dispatchNumber",
    key: "dispatchNumber",
    sorter: (a, b) => (a.dispatchNumber || '').toString().localeCompare((b.dispatchNumber || '').toString()),
  },
  {
    title: "Order Number",
    dataIndex: "orderNumbers",
    key: "orderNumbers",
    sorter: (a, b) => (a.orderNumbers || '').toString().localeCompare((b.orderNumbers || '').toString()),
  },
  {
    title: "PO Number",
    dataIndex: "poNumber",
    key: "poNumber",
    sorter: (a, b) => (a.poNumber || '').toString().localeCompare((b.poNumber || '').toString()),
  },
  {
    title: "PO Date",
    dataIndex: "poDate",
    key: "poDate",
    sorter: (a, b) => (a.poDate || '').toString().localeCompare((b.poDate || '').toString()),
  },
  {
    title: "Vehicle Number",
    dataIndex: "vehicleNumber",
    key: "vehicleNumber",
    sorter: (a, b) => (a.vehicleNumber || '').toString().localeCompare((b.vehicleNumber || '').toString()),
  },
  {
    title: "LR Number",
    dataIndex: "lrNo",
    key: "lrNo",
    sorter: (a, b) => (a.lrNo || '').toString().localeCompare((b.lrNo || '').toString()),
  },
  {
    title: "Payment Terms",
    dataIndex: "paymentTerms",
    key: "paymentTerms",
    sorter: (a, b) => (a.paymentTerms || '').toString().localeCompare((b.paymentTerms || '').toString()),
  },
  {
    title: "Packing Charges",
    dataIndex: "packingCharges",
    key: "packingCharges",
    sorter: (a, b) => parseFloat(a.packingCharges || 0) - parseFloat(b.packingCharges || 0),
  },
  {
    title: "Freight",
    dataIndex: "freight",
    key: "freight",
    sorter: (a, b) => parseFloat(a.freight || 0) - parseFloat(b.freight || 0),
  },
  {
    title: "Final Total",
    dataIndex: "finalTotal",
    key: "finalTotal",
    sorter: (a, b) => parseFloat(a.finalTotal || 0) - parseFloat(b.finalTotal || 0),
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
    
        <span
          type="button"
          style={{ fontSize: "14px", color: "#52c41a", cursor: "pointer" }}
          // onClick={() => handlePrint(record)}
          title="Print"
        >
          <i className="fa-solid fa-print"></i>
        </span>
      </div>
    ),
  },
];

    const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023E7D",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };

    // Fetch Customer, Consignee Names
     let isDeliveryDispatchSummaryFetched = false;
     useEffect(() => {
       if (isDeliveryDispatchSummaryFetched) return;
      //  fetchConsignee();
       fetchCustomer();
       handleViewData();
        isDeliveryDispatchSummaryFetched = true;
     }, []);
  // Fetch Customer, Consignee Names

      useEffect(() => {
   

        if(customerName){
         fetchConsignee();
         fetchDispatchNumber();
        }

        if(customerName && dispatchNumber){
          fetchOrderNumber();
        }
  // if(customerName && dispatchNumber && orderNo){
  //        fetchOrderDetails();
  //       }        
      }, [customerName ,dispatchNumber]);
   // ==============Get Table Data================
 
   let isError = false;
 
   const fetchConsignee = async () => {
     try {
         const response = await axios.get(`${GetConsigneeForCustomer}?customerId=${customerName}`,commonHeaders1);
       if (response.data !== null) {
         setAllConsignees(response.data);
        
       }
     } catch (error) {
       if (!isError) {
         console.error("Error fetching Consignee:", error);
         toast.error("Failed to fetch Consignee data");
         isError = true; 
       }
     }
   };
 

  const fetchCustomer = async () => {
    try {
      const response = await axios.get(GetCustomerMaster,commonHeaders1);
      if (response.data !== null) {
        setAllCustomer(response.data);
      
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customer:", error);
        toast.error("Failed to fetch Customer data");
        isError = true; 
      }
    }
  };
  const fetchDispatchNumber = async () => {
    try {
      const response = await axios.get(`${DispatchNumberByCustomerId}?customerId=${customerName}`,commonHeaders1);
      if (response.data !== null) {
        setDispatchNumbers(response.data);
      
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Customer:", error);
        toast.error("Failed to fetch Customer data");
        isError = true; 
      }
    }
  };
  const fetchOrderNumber = async () =>{
    try {
        const response = await axios.get(`${GetDetailsByDispatchNUmberId}?dispatchNumberId=${dispatchNumber}`,commonHeaders1);
        if (response.data !== null) {
         setAllOrders(response.data);
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching :", error);
          toast.error("Failed to fetch  data");
          isError = true; 
        }
      }
  }
const handleOrderNumberChange = async (value) => {
  setOrderNo(value);

  const selectedOrder = allOrders.find((order) => order.orderNumberIds === value);
  if (!selectedOrder) return;
  setPONumber(selectedOrder.poNumber || "");
  setPODate(selectedOrder.poDate || "");
  // Check if already selected
  const alreadyExists = selectedOrders.some((entry) => entry.orderNumberIds === value);
  if (alreadyExists) {
    toast.warn("Order already added");
    return;
  }

  // Add to selected orders list
  setSelectedOrders((prev) => [
    ...prev,
    {
      ordernumberIds: selectedOrder.orderNumberIds,
      poNumber: selectedOrder.poNumber || "",
      poDate: selectedOrder.poDate || "",
    },
  ]);

  // Fetch and append order details
  try {
    const response = await axios.get(
      `${GetOrderDetailsDispatchDeliveryByOrderNumber}?orderNumberId=${value}`,
      commonHeaders1
    );

    if (response.data === "NOTALLOCATED") {
      toast.warn("Not Allocated");
      return;
    }

    if (Array.isArray(response.data) && response.data.length > 0) {
      setOrderDetailsData((prev) => [...prev, ...response.data]);
       
            setFilteredData1((prev) => {
  const updated = [...prev, ...response.data];
  setTotalEntries1(updated.length); // Set total to updated length
  return updated;
});
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    toast.error("Failed to fetch data");
  }
};
const   handleCancel = () =>{
  setDispatchNumber("");
  setVehicleNumber("");
setDispatchData([]);
setAllOrders([]);
setOrderNo("");
setLRNo("");
setPaymentTerms("");
setFreight("");
setFinalTotal("");
 setSelectedOrders([]);
 setCustomerName("");
 setConsigneeName("");
    setAllConsignees([]);
    // setAllCustomer([]);
    setFilteredData1([]);
    setTotalEntries1(0);
    setPODate("");
    setPONumber("");
      setFinalTotal("");
    setSummaryDate("");
    setPackingCharges("");

}

useEffect(() => {
  const total = parseFloat(packingCharges || 0) + parseFloat(freight || 0);
  setFinalTotal(total.toFixed(2));
}, [packingCharges, freight]);
   //======Todays JobWork Details Data Table===============

   const [OrderDetailsData, setOrderDetailsData] = useState([])
   const [filteredData1, setFilteredData1] = useState([])
   const [pageSize1, setPageSize1] = useState(10)
   const [currentPage1, setCurrentPage1] = useState(1)
   const [totalEntries1, setTotalEntries1] = useState(0)
 
   const [selectedOrders, setSelectedOrders] = useState([])
 
   const handleSearch1 = (value) => {
     const searchValue = value.toLowerCase();
   
     const filtered = OrderDetailsData.filter((item) =>
       Object.values(item).some((val) =>
         String(val ?? "").toLowerCase().includes(searchValue)
       )
     );
   
     setFilteredData1(filtered);
     setTotalEntries1(filtered.length);
     setCurrentPage1(1);
   };
   
 
   const handlePageSizeChange1 = (value) => {
     setPageSize1(value)
   }
   const fetchOrderDetails = async () => {
     try {
      const response = await axios.get(`${GetOrderDetailsDispatchDeliveryByOrderNumber}?orderNumberId=${orderNo}`, commonHeaders1)
     
           if(response.data === 'NOTALLOCATED'){
              toast.warn("Not Allocated ");
            }
if (Array.isArray(response.data) && response.data.length > 0) {
              setOrderDetailsData(response.data);
              setFilteredData1(response.data);
              setTotalEntries1(response.data.length);
            
               
            }
     } catch (error) {
       if (!isError) {
         console.error('Error fetching Data:', error)  
         toast.error('Failed to fetch Data')
         isError = true // Set the flag to prevent double toast
       }
     }
   }

const orderDetailscolumns = [
  {
    title: 'ORDER NO.',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
  },
  {
    title: 'BUNDLES/PACKAGE',
    dataIndex: 'pcsPerBundle',
    key: 'pcsPerBundle',
  },
  {
    title: 'HSN',
    dataIndex: 'hsn',
    key: 'hsn',
  },
  {
    title: 'QTY',
    dataIndex: 'qty',
    key: 'qty',
  },
    {
    title: 'PACKING RATE',
    dataIndex: 'qtyTimesPackingRate',
    key: 'qtyTimesPackingRate',
  },
  {
    title: 'PACKING x QTY',
    dataIndex: 'qtyTimesPackingRate',
    key: 'qtyTimesPackingRate',
  },
  {
    title: 'BASIC + PREMIUM',
    dataIndex: 'basicPlusPremium',
    key: 'basicPlusPremium',
  },

  {
    title: 'AMOUNT',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: 'RATE STATUS',
    dataIndex: 'status',
    key: 'status',
  },
];
 const components1 = {
     header: {
       cell: ({ children, ...restProps }) => (
         <th
           {...restProps}
           style={{
             backgroundColor: '#000',
             color: '#fff',
             padding: '10px',
             fontSize: '15px',
             borderRadius: '0px',
           }}
         >
           {children}
         </th>
       ),
     },
     body: {
       row: ({ children, ...restProps }) => (
         <tr
           {...restProps}
           style={{
             backgroundColor: '#f0f7fd',
           }}
         >
           {children}
         </tr>
       ),
       cell: ({ children, ...restProps }) => (
         <td
           {...restProps}
           style={{
             padding: '8px',
                         fontSize: '15px',

           }}
         >
           {children}
         </td>
       ),
     },
   }
   //======================================== Save the delivery data ===========================================================
     const handleSubmit = async () => {
       let isValid = true
       const errorObj = {}
   
 if (!vehicleNumber) {
       isValid = false;
       errorObj.vehicleNumber = "Vehicle Number is required";
     }
     if (!summaryDate) {
     isValid = false;
     errorObj.summaryDate = " Date is required";  
   }
       if (!customerName) {
     isValid = false;
     errorObj.customerName = " Customer is required";  
   }
      if (!consigneeName) {
     isValid = false;
     errorObj.consigneeName = " Consignee is required";  
   }
       if (!orderNo) {
     isValid = false;
     errorObj.orderNo = " Order No. is required";  
   }
       if (!freight) {
     isValid = false;
     errorObj.freight = " Freight is required";  
   }
       if (!dispatchNumber) {
     isValid = false;
     errorObj.dispatchNumber = " Date is required";  
   }
       if (!lrNo) {
     isValid = false;
     errorObj.lrNo = " LR No. is required";  
   }    if (!packingCharges) {
     isValid = false;
     errorObj.packingCharges = " Packing Charges is required";  
   }    if (!paymentTerms) {
     isValid = false;
     errorObj.paymentTerms = " Payment Terms is required";  
   }
   
       setErrors(errorObj) // Set error messages
   
       if (!isValid) return
     const selectedOrders = allOrders.filter(
    (entry) => entry.orderNumberIds && entry.poNumber && entry.poDate
  );

   const orderNumberIds = selectedOrders.map((entry) => entry.orderNumberIds);
  const poNumbers = selectedOrders.map((entry) => entry.poNumber).join(", ");
  const poDates = selectedOrders
    .map((entry) => dayjs(entry.poDate).format("YYYY-MM-DD"))
    .join(",");
   
       const payload = {
    customerId: customerName,
  date: dayjs(summaryDate).format("YYYY-MM-DD"),
  consigneeId: consigneeName,
  dispatchId: dispatchNumber,
  orderNumberIds: orderNumberIds,
  poNumber: poNumbers,
  poDate:poDates,
  vehicleNumber: vehicleNumber,
  lrNo: lrNo,
  paymentTerms: paymentTerms,
  packingCharges: packingCharges,
  freight: freight,
  finalTotal: finalTotal,

       }
   
       try {
         const response = await axios.post(
          DispatchDeliverySummarySave,
           payload,
           commonHeaders,
         )
         if (response.data == 'CREATED') {
           toast.success('Data submitted successfully!')
           handleCancel();
           handleViewData();             
          
         
           
         }
         else if (response.data == "ALREADYEXISTED") {
           toast.warn('Data Already Exist!')
         }
       } catch (err) {
         console.error('Error submitting data', err)
       }
     }
   //========================================================================================================= 
//============================== Print Report ================================================================
  // const handleShowPdf = async () => {
  //   let isValid = true
  //   const errorObj = {}

  //   if (rackNo) {
  //     isValid = false
  //     errorObj.rackNo = 'Rack No. is required *'
  //   }

  //   setErrors(errorObj)
  //   if (!isValid) return

  //   const url = `${GetRackReleaseReportData}?rackNo=${rackNo}`

  //   try {
  //     const response = await axios.get(url, commonHeaders1)

  //     if (response.data !== null) {
  //       if (
  //         response.data === 'NOTFOUND' ||
  //         response.data === 'NODATA' ||
  //         response.status === 204
  //       ) {
  //         toast.warn('No data available!', {
  //           position: 'top-right',
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         })

  //         setLoading(false)
  //         return // Exit function early
  //       }
  
  //       let reportUrl = response.data
  //       if (reportUrl === 'NOTFOUND') {
  //         toast.warn('Report File Not Found...!!', {
  //           position: 'top-right',
  //           autoClose: 2000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //         })
  //       } else {
  //         const reportLink = BaseIPForPDF + `output/${reportUrl}`
  //         window.open(reportLink, '_blank')
  //       }
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     console.error('Error during API call:', error)
  //     toast.error('Error occurred while submitting data')
  //   }
  // }

     return (
       <div className="px-5 py-3 " style={{ fontSize: "15px" }}> 
  <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
           
     <div className="col-12">
  <div className="row">
    {/* JobWork No. */}
  <div className="col-12">
  <div className="row gx-2"> {/* Reduce horizontal spacing between columns */}
 <div className='row'>
    {/* <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Loading Summary No.</label>
      <Input
        value={loadingSummaryNo}
        onChange={(e) => setLoadingSummaryNo(e.target.value)}
        placeholder="Enter Summary No"
        style={{ width: '100%' }}
      />
      {errors.loadingSummaryNo && <div className="errorField">{errors.loadingSummaryNo}</div>}
    </div> */}

    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Date</label>
      <DatePicker
        value={summaryDate}
        onChange={(date) => setSummaryDate(date)}
        style={{ width: '100%' }}
          format={dateFormatList}
      />
      {errors.summaryDate && <div className="errorField">{errors.summaryDate}</div>}
    </div>
</div>
 
  


  
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Customer Name</label>
      <Select
        value={customerName || undefined}
        onChange={(value) => setCustomerName(value)}
        placeholder="Select Customer"
        style={{ width: '100%' }}
        showSearch
                              optionFilterProp="children"

      >
        {allCustomer.map((c) => (
          <Option key={c.id} value={c.id}>
            {c.customerName}
          </Option>
        ))}
      </Select>
      {errors.customerName && <div className="errorField">{errors.customerName}</div>}
    </div>

   <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Consignee Name</label>
      <Select
        value={consigneeName || undefined}
        onChange={(value) => setConsigneeName(value)}
        placeholder="Select Consignee"
        style={{ width: '100%' }}
        showSearch
                              optionFilterProp="children"

      >
        {allConsignees.map((c) => (
          <Option key={c.consigneeId} value={c.consigneeId}>
            {c.consigneeName}
          </Option>
        ))}
      </Select>
      {errors.consigneeName && <div className="errorField">{errors.consigneeName}</div>}
    </div>

      <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Dispatch Number</label>
      <Select
        value={dispatchNumber || undefined}
        onChange={(value) => setDispatchNumber(value)}
        placeholder="Select Customer"
        style={{ width: '100%' }}
        showSearch
                              optionFilterProp="children"

      >
         {dispatchNumbers.map((num) => (
      <Option key={num} value={num}>
        {num}
      </Option>
    ))}
      </Select>
       {errors.dispatchNumber && <div className="errorField">{errors.dispatchNumber}</div>}
    </div>


 
      <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Order Number</label>
       <Select
        value={orderNo || undefined}
      onChange={(value) => handleOrderNumberChange(value)} 
        placeholder="Select Order Number"
        style={{ width: '100%' }}
        showSearch 
                              optionFilterProp="children"

      >
        {allOrders.map((c) => (
          <Option key={c.orderNumberIds} value={c.orderNumberIds}>
            {c.orderNumber}
          </Option>
        ))}
      </Select>
      {errors.orderNo && <div className="errorField">{errors.orderNo}</div>}
    </div>
    <div className="col-md-4 mb-3">
      <label className="labels">PO Number</label>
      <Input
        value={poNumber}
        onChange={(e) => setPONumber(e.target.value)}
      
        style={{ width: '100%', backgroundColor: "#e9e9e9"  }}
        readOnly
      />
    </div>

    <div className="col-md-4 col-lg-4 py-1">
    
      <label className="labels">PO Date</label>
      <Input
        value={poDate}
        onChange={(e) => setPODate(e.target.value)}
         
        style={{ width: '100%', backgroundColor: "#e9e9e9" }}
        readOnly
      />
    </div>

    


 
  <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Vehicle Number</label>
      <Input
        value={vehicleNumber}
        onChange={(e) => setVehicleNumber(e.target.value)}
        placeholder="Enter Vehicle Number"
        style={{ width: '100%' }}
      />
         {errors.vehicleNumber && <div className="errorField">{errors.vehicleNumber}</div>}
    </div>
     <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">LR Number</label>
      <Input
        value={lrNo}
        onChange={(e) => setLRNo(e.target.value)}
        placeholder="Enter LR Number"
        style={{ width: '100%' }}
      />
      {errors.lrNo && <div className="errorField">{errors.lrNo}</div>}
    </div>

      <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Payment Terms</label>
      <Input
        value={paymentTerms}
        onChange={(e) => setPaymentTerms(e.target.value)}
        placeholder="Enter Payment Terms"
        style={{ width: '100%' }}
      />
       {errors.paymentTerms && <div className="errorField">{errors.paymentTerms}</div>}
    </div>
 {/* Table */}
  <div className="col-12 py-2"  style={{  backgroundColor: "white" }}>

    <div
                                    className="col-12 px-lg-5"
                                    style={{ display: "flex", justifyContent: "space-between" }}
                                  >
                                    <div>
                                      <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                                      <Select
                                        defaultValue={pageSize1}
                                        onChange={handlePageSizeChange1}
                                        style={{ width: 120, textAlign: "center" }}
                                      >
                                        <Option value={10}>10</Option>
                                        <Option value={20}>20</Option>
                                        <Option value={30}>30</Option>
                                      </Select>
                                    </div>
          
                                    <div className="pt-4 pt-lg-0">
                                      <Input.Search
                                        placeholder="Search"
                                        onChange={(e) => handleSearch1(e.target.value)}
                                        style={{ width: 200, marginBottom: 16 }}
                                      />
                                    </div>
                                  </div>
          
                                  <div style={{ backgroundColor: "white" }}>
                                    <Table
                                      bordered
                                      style={{ padding: "0px 20px", overflowX: "auto" }}
                            columns={orderDetailscolumns}
                    dataSource={filteredData1}
                                      pagination={{
                                        pageSize: pageSize1,
                                        total: totalEntries1,
                                        showTotal: (total, range) =>
                                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                        current: currentPage1,
                                        onChange: (page) => setCurrentPage1(page),
                                      }}
                                      showSorterTooltip={false}
                                      rowKey={(record) => record.orderNumberId}
                                      components={components1}
                                            size="small"
                                    />
                                  </div>

  </div>
  
 


     <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Packing Charges</label>
      <Input
        value={packingCharges}
        onChange={(e) => setPackingCharges(e.target.value)}
        placeholder="Enter Packing Charges"
        style={{ width: '100%' }}
      />
      {errors.packingCharges && <div className="errorField">{errors.packingCharges}</div>}
    </div>
    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Freight</label>
      <Input
        value={freight}
        onChange={(e) => setFreight(e.target.value)}
        placeholder="Enter Freight"
        style={{ width: '100%' }}
      />
       {errors.freight && <div className="errorField">{errors.freight}</div>}
    </div>

    <div className="col-md-4 col-lg-4 py-1">
      <label className="labels">Final Total</label>
      <Input
        value={finalTotal}
      readOnly
        placeholder="Auto-calculated"
        style={{ width: '100%', backgroundColor: "#e9e9e9"  }}
      />
    </div>

 


  {/* Submit / Cancel */}
  <div className="col-12 text-center">
    <Button type="submit" className="CancelBtn mx-1" onClick={handleCancel}>Cancel</Button>

      <Button type="submit" onClick={handleSubmit} className="SubmitBtn mx-1">Submit</Button>
    
  </div>


      </div>
    </div>
    <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>


         
           {/*================ Table =========================*/}
      <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
             <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
           
             
               <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                 <div>
                   <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                   <Select
                     defaultValue={pageSize}
                     onChange={handlePageSizeChange}
                     style={{ width: 120, textAlign: "center" }}
                   >
                     <Option value={10}>10</Option>
                     <Option value={20}>20</Option>
                     <Option value={30}>30</Option>
                   </Select>
                 </div>
         
                 <div className="pt-4 pt-md-0">
                   <Input.Search
                     placeholder="Search"
                 onChange={(e) => handleSearch(e.target.value)}
                     style={{ width: 200, marginBottom: 16 }}
                   />
                 </div>
               </div>
         
               <div style={{ backgroundColor: "white" }}>
                 <Table
                   bordered
                   style={{ padding: "0px 20px", overflowX: "auto" }}
                   columns={columns}
                   dataSource={filteredData}
                   pagination={{
                     pageSize: pageSize,
                     total: totalEntries,
                     showTotal: (total, range) =>
                       `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                     current: currentPage,
                     onChange: (page) => setCurrentPage(page),
                   }}
                   showSorterTooltip={false}
                   rowKey={(record) => record.id}
                   components={components}
                 />
               </div>
             </div>
           </div>
         </div>
         </div>
         </div>
         </div>
         )
         
}

export default DispatchDeliverySummary